/**
 * ProtectedRoute -- redirects unauthenticated users to /login.
 *
 * Reads the auth token from useAuthStore (ADR-021).
 */
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../state/useAuthStore';

export function ProtectedRoute() {
  const token = useAuthStore((s) => s.token);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
